// accountsModal.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Table, Button, Form } from "react-bootstrap";
import { formatCurrency } from "../../../../../utils/numberFormatter";
import { PaginationControls } from "../../../../../hooks/customHook/paginationHook/usePagination"; // Import our custom hook and component
import BASE_URL from "../../../../../assets/global/url";
import useAccountsData from "../../../../../hooks/useAccountsData";

const AccountsModal = ({
  show,
  onClose,
  selectedAccounts,
  setSelectedAccounts,
  cutoff_TO,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  // const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState(selectedAccounts);
  //   const [pageSize, setPageSize] = useState(10);

  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    if (show) {
      setSelectedRows(selectedAccounts);
    }
  }, [show]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);
    return () => clearTimeout(timer); // ✅ cleanup works correctly here
  }, [searchTerm]);

  // Use the debounced value in the hook instead
  const { accountsData } = useAccountsData(debouncedSearch);

  const allSelected = accountsData.data.every((r) =>
    selectedRows.some((row) => row.id === r.id),
  );
  const toggleAll = () => {
    if (allSelected) {
      setSelectedRows((prev) =>
        prev.filter((row) => !accountsData.data.find((r) => r.id === row.id)),
      );
    } else {
      const pageRows = accountsData.data.map((r) => ({
        id: r.id,
        account_name: r.account_name, // adjust to your actual field name
        amount: r.amount, // adjust to your actual field name
        currency: r.currency.currency_name, // adjust to your actual field name
      }));
      setSelectedRows((prev) => {
        const existingIds = new Set(prev.map((r) => r.id));
        const newRows = pageRows.filter((r) => !existingIds.has(r.id));
        return [...prev, ...newRows];
      });
    }
  };

  const toggleRow = (row) => {
    // pass the full row object instead of just id
    setSelectedRows((prev) =>
      prev.some((r) => r.id === row.id)
        ? prev.filter((r) => r.id !== row.id)
        : [
            ...prev,
            {
              id: row.id,
              account_name: row.account_name,
              amount: row.amount,
              currency_name: row.currency.currency_name,
            }, // adjust to your actual field names
          ],
    );
  };

  //   const allSelected =
  //     accountsData.data.length > 0 &&
  //     accountsData.data.every((row) => selectedRows.includes(row.id));

  //   const toggleAll = () => {
  //     if (allSelected) {
  //       setSelectedRows((prev) =>
  //         prev.filter((id) => !accountsData.data.find((r) => r.id === id)),
  //       );
  //     } else {
  //       const pageIds = accountsData.data.map((r) => r.id);
  //       setSelectedRows((prev) => [...new Set([...prev, ...pageIds])]);
  //     }
  //   };

  //   const toggleRow = (id) => {
  //     setSelectedRows((prev) =>
  //       prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id],
  //     );
  //   };

  // const handleSubmit = async () => {
  //   // const addValuesToSelectedRows = await Promise.all(
  //   //   selectedRows.map((data) => {
  //   //     const selected_id = data.id;

  //   //     return axios.get(
  //   //       `${BASE_URL}/bankBudgeting/getPayableCheckAndBankTransaction`,
  //   //       {
  //   //         params: {
  //   //           selected_account_ids: selected_id,
  //   //           cutoff_TO_date: cutoff_TO,
  //   //         },
  //   //       },
  //   //     );
  //   //   }),
  //   // );

  //   // setSelectedAccounts((prev) => [
  //   //   // ...new Set([...prev, ...addValuesToSelectedRows]),
  //   //   ...new Set([...selectedRows]),
  //   // ]);

  //   const resolvedData = await Promise.all(
  //     selectedRows.map((data) =>
  //       axios.get(
  //         `${BASE_URL}/bankBudgeting/getPayableCheckAndBankTransaction`,
  //         {
  //           params: {
  //             selected_account_ids: data.id,
  //             cutoff_TO_date: cutoff_TO,
  //           },
  //         },
  //       ),
  //     ),
  //   );

  //   // console.log(`resolvedData`, resolvedData);
  //   // Merge each row with its corresponding API response value
  //   const rowsWithValues = selectedRows.map((row, index) => ({
  //     ...row,
  //     disbursementSumPayables: resolvedData[index].data, // adds the value to each row
  //     allocated_payables: 0,
  //     allocated_receivables: 0,
  //   }));

  //   setSelectedAccounts((prev) => {
  //     // Avoid duplicates based on id
  //     const existingIds = new Set(prev.map((item) => item.id));
  //     const newRows = rowsWithValues.filter((row) => !existingIds.has(row.id));
  //     return [...prev, ...newRows];
  //   });

  //   onClose();
  // };
  const handleSubmit = async () => {
    // Find only newly added rows (not already in selectedAccounts)
    const existingIds = new Set(selectedAccounts.map((item) => item.id));
    const newRows = selectedRows.filter((row) => !existingIds.has(row.id));

    const resolvedData = await Promise.all(
      newRows.map((data) =>
        axios.get(
          `${BASE_URL}/bankBudgeting/getPayableCheckAndBankTransaction`,
          {
            params: {
              selected_account_ids: data.id,
              cutoff_TO_date: cutoff_TO,
            },
          },
        ),
      ),
    );

    const newRowsWithValues = newRows.map((row, index) => ({
      ...row,
      disbursementSumPayables: resolvedData[index].data,
      allocated_payables: 0,
      allocated_receivables: 0,
    }));

    // Preserve existing accounts that are still selected, remove unchecked ones
    const selectedIds = new Set(selectedRows.map((r) => r.id));
    const keptAccounts = selectedAccounts.filter((acc) =>
      selectedIds.has(acc.id),
    );

    setSelectedAccounts([...keptAccounts, ...newRowsWithValues]);
    onClose();
  };
  // console.log(`selectedAccounts`, selectedAccounts);
  const handleClose = () => {
    setSearchTerm("");
    // setSelectedRows([]);
    // setCurrentPage(1);
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      {/* Header */}
      <Modal.Header
        className="border-0 pb-0 px-4 pt-4"
        closeButton
        style={{ alignItems: "flex-start" }}>
        <Modal.Title className="fw-bold fs-5 accounts-modal-title">
          Account List
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 pt-3 pb-2">
        {/* Search Bar */}
        <div className="d-flex gap-2 mb-3">
          <div className="position-relative flex-grow-1">
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pe-5 accounts-modal-search"
              style={{
                borderRadius: "8px",
                fontSize: "0.9rem",
              }}
            />
          </div>
        </div>

        {/* Table */}
        <div
          className="border rounded"
          style={{ borderRadius: "10px", overflow: "hidden" }}>
          <Table className="mb-0 align-middle" hover>
            <thead>
              <tr style={{ backgroundColor: "#3d3d8f", color: "#fff" }}>
                <th className="ps-3 py-3" style={{ width: 44 }}>
                  <Form.Check
                    type="checkbox"
                    // checked={allSelected}
                    onChange={toggleAll}
                    className="ms-1"
                    style={{ accentColor: "#fff" }}
                  />
                </th>
                <th
                  className="py-3 fw-semibold"
                  style={{ fontSize: "0.85rem" }}>
                  Account Name
                </th>
                <th
                  className="py-3 fw-semibold"
                  style={{ fontSize: "0.85rem" }}>
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {accountsData.data.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">
                    No records found.
                  </td>
                </tr>
              ) : (
                accountsData.data.map((data, i) => (
                  <tr
                    key={data.id}
                    className="accounts-modal-row"
                    style={{ cursor: "pointer" }}
                    // onClick={() => toggleRow(data.id)}
                    onClick={() => toggleRow(data)}>
                    <td className="ps-3 py-3">
                      <Form.Check
                        type="checkbox"
                        // checked={selectedRows.includes(data.id)}
                        checked={selectedRows.some((row) => row.id === data.id)}
                        // onChange={() => toggleRow(data.id)}
                        onChange={() => toggleRow(data)}
                        onClick={(e) => e.stopPropagation()}
                        className="ms-1"
                      />
                    </td>
                    <td
                      className="py-3 text-muted"
                      style={{ fontSize: "0.9rem" }}>
                      {data.account_name}
                      {/* {} */}
                    </td>

                    <td className="py-3 pe-4" style={{ fontSize: "0.9rem" }}>
                      {formatCurrency(data.amount, data.currency.currency_name)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
          <PaginationControls {...accountsData} />
        </div>
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer className="border-0 pt-2 pb-4 px-4">
        <Button
          variant="secondary"
          onClick={handleClose}
          style={{ borderRadius: "8px", minWidth: "90px", fontWeight: 500 }}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          style={{
            borderRadius: "8px",
            minWidth: "90px",
            fontWeight: 500,
            backgroundColor: "#3d3d8f",
            borderColor: "#3d3d8f",
          }}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AccountsModal;
